<aside class="left_sidebars">
  <ul class="aside_list">
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'dashboard' }"
      [routerLink]="['/dashboard']"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'dashboard' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M8 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H8C9.10457 22 10 21.1046 10 20V4C10 2.89543 9.10457 2 8 2ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H8C10.2091 24 12 22.2091 12 20V4C12 1.79086 10.2091 0 8 0H4ZM16 4V5C16 6.10457 16.8954 7 18 7L20 7C21.1046 7 22 6.10457 22 5V4C22 2.89543 21.1046 2 20 2L18 2C16.8954 2 16 2.89543 16 4ZM14 5C14 7.20914 15.7909 9 18 9H20C22.2091 9 24 7.20914 24 5V4C24 1.79086 22.2091 0 20 0H18C15.7909 0 14 1.79086 14 4V5ZM16 20V15C16 13.8954 16.8954 13 18 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20ZM18 24C15.7909 24 14 22.2091 14 20V15C14 12.7909 15.7909 11 18 11H20C22.2091 11 24 12.7909 24 15V20C24 22.2091 22.2091 24 20 24H18Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Dashboard</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'artists' }"
      [routerLink]="['/artists']"
      *ngIf="checkData('artists')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'artists' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            class="active_icon"
            clip-rule="evenodd"
            d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Users</p>
      </div>
    </li><li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'contents' }"
      [routerLink]="['/contents']"
      *ngIf="checkData('contents')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'contents' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            class="active_icon"
            clip-rule="evenodd"
            d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Contents</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'stream-tokens-slab' }"
      [routerLink]="['/stream-tokens-slab']"
      *ngIf="checkData('stream-tokens-slab')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'stream-tokens-slab' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            class="active_icon"
            clip-rule="evenodd"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Stream Managament</p>
      </div>
    </li>
<!--    <li-->
<!--      class="cursor-pointer"-->
<!--      [ngClass]="{ activelist: currentRoute === 'listeners' }"-->
<!--      [routerLink]="['/listeners']"-->
<!--      *ngIf="checkData('listeners')"-->
<!--    >-->
<!--      <div-->
<!--        class="lsit_item"-->
<!--        [ngClass]="{ list_active: currentRoute === 'listeners' }"-->
<!--      >-->
<!--        <svg-->
<!--          width="24"-->
<!--          height="24"-->
<!--          viewBox="0 0 24 24"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            fill-rule="evenodd"-->
<!--            class="active_icon"-->
<!--            clip-rule="evenodd"-->
<!--            d="M4.69571 12.837C3.91861 12.837 3.18219 12.6687 2.52836 12.3504V16.1415C2.52836 20.4962 4.04934 22.1698 8.28193 22.3151V20.3718C8.28193 18.0276 9.60787 16.7439 12.0292 16.7439C14.4504 16.7439 15.7764 18.0276 15.7764 20.3718V22.3147C19.9999 22.1667 21.5181 20.4921 21.5181 16.1415V12.3274C20.8528 12.6606 20.0998 12.837 19.3043 12.837C17.8587 12.837 16.5099 12.1387 15.6327 11.0734C15.5322 11.2126 15.4223 11.3467 15.3031 11.4752C14.4499 12.357 13.2969 12.837 12.0286 12.837C10.7603 12.837 9.60731 12.357 8.78869 11.4752C8.65229 11.3282 8.52806 11.1739 8.4163 11.0129C7.54081 12.1122 6.16848 12.837 4.69571 12.837ZM0.0261021 7.84733C-0.091701 8.96883 0.191702 10.0418 0.826495 10.9215C0.808479 10.9881 0.798873 11.0579 0.798873 11.1295V16.1415C0.798873 21.6447 3.22015 24 8.91592 24H15.1421C20.8263 24 23.2591 21.6447 23.2476 16.1415V11.1295C23.2476 11.0413 23.233 10.9559 23.2061 10.8757C23.818 10.0047 24.0897 8.94944 23.9739 7.84733L23.6511 4.74412C23.1783 1.373 21.5987 0 18.209 0H14.7381H14.6923H9.35365C9.3459 0 9.33817 9.9642e-05 9.33047 0.000297329C9.32288 9.93226e-05 9.31528 0 9.30767 0H5.79105C2.40126 0 0.821665 1.373 0.337409 4.77761L0.0261021 7.84733ZM5.79105 1.67439C3.266 1.67439 2.42432 2.41113 2.05536 4.96737L1.74406 8.01477C1.65182 8.86313 1.91701 9.65567 2.47044 10.2473C3.02388 10.8389 3.80791 11.1626 4.69571 11.1626C6.14848 11.1626 7.49748 9.97939 7.63583 8.58406L8.35069 1.67439H5.79105ZM14.6367 8.77024C14.614 9.36313 14.3872 9.91594 13.9887 10.3478C13.0086 11.397 11.0485 11.397 10.0685 10.3478C9.58425 9.83428 9.35365 9.13103 9.43436 8.38313L10.1262 1.67439H13.9047L14.6347 8.7515L14.6367 8.77024ZM16.3975 8.802C16.6549 10.1004 17.9278 11.1626 19.3043 11.1626C20.1806 11.1626 20.9646 10.8389 21.5296 10.2473C22.083 9.65567 22.3367 8.86313 22.2559 8.01477L21.9331 4.94504C21.5757 2.42229 20.734 1.67439 18.209 1.67439H15.6977L16.3754 8.21569C16.3958 8.41342 16.4031 8.60912 16.3975 8.802ZM14.0469 20.3718V22.3253H10.0114V20.3718C10.0114 18.9653 10.5764 18.4183 12.0292 18.4183C13.4819 18.4183 14.0469 18.9653 14.0469 20.3718Z"-->
<!--            fill="#D1D6DC"-->
<!--          />-->
<!--        </svg>-->
<!--        <p class="item_text">Listeners</p>-->
<!--      </div>-->
<!--    </li>-->
    <li class="cursor-pointer" [routerLink]="['/inbox']" [ngClass]="{ activelist: currentRoute === 'inbox' }" *ngIf="checkData('inbox')">
      <div
        class="lsit_item"
        tooltip="Coming soon"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M1.67442 7.51391C1.67442 5.41626 2.19973 3.99637 3.10362 3.09499C4.00752 2.19361 5.43138 1.66976 7.53488 1.66976H16.4651C18.5686 1.66976 19.9925 2.19361 20.8964 3.09499C21.8003 3.99637 22.3256 5.41626 22.3256 7.51391V13.0798C22.3256 15.1774 21.8003 16.5973 20.8964 17.4987C19.9925 18.4001 18.5686 18.9239 16.4651 18.9239H15.907C15.2953 18.9239 14.7154 19.216 14.3474 19.6989L14.3442 19.7032L12.6698 21.9295C12.4363 22.2399 12.1856 22.3302 12 22.3302C11.8144 22.3302 11.5637 22.2399 11.3302 21.9295L9.65877 19.7071C9.46571 19.4451 9.19594 19.2595 8.95743 19.1416C8.71587 19.0222 8.40872 18.9239 8.09302 18.9239H7.53488C5.31713 18.9239 3.92803 18.633 3.06293 17.8782C2.22549 17.1475 1.67442 15.7907 1.67442 13.0798V7.51391ZM7.53488 0C5.17327 0 3.24829 0.589325 1.91963 1.91429C0.590969 3.23925 0 5.15888 0 7.51391V13.0798C0 15.9347 0.565209 17.9175 1.96032 19.1348C3.32778 20.328 5.28752 20.5937 7.53488 20.5937H8.08738C8.09041 20.5941 8.09999 20.5956 8.11616 20.5999C8.14362 20.6073 8.17784 20.6199 8.21374 20.6376C8.24972 20.6554 8.27902 20.6743 8.2992 20.6899C8.30739 20.6963 8.31242 20.7008 8.3149 20.7032L8.31628 20.705L9.9907 22.9314C10.494 23.6005 11.2145 24 12 24C12.7855 24 13.506 23.6005 14.0093 22.9314L15.6805 20.7093L15.6817 20.7077C15.7379 20.635 15.8271 20.5937 15.907 20.5937H16.4651C18.8267 20.5937 20.7517 20.0044 22.0804 18.6794C23.409 17.3544 24 15.4348 24 13.0798V7.51391C24 5.15888 23.409 3.23925 22.0804 1.91429C20.7517 0.589325 18.8267 0 16.4651 0H7.53488ZM16.4612 9.74026C15.8447 9.74026 15.3449 10.2386 15.3449 10.8534C15.3449 11.4682 15.8447 11.9666 16.4612 11.9666H16.4712C17.0877 11.9666 17.5875 11.4682 17.5875 10.8534C17.5875 10.2386 17.0877 9.74026 16.4712 9.74026H16.4612ZM10.8787 10.8534C10.8787 10.2386 11.3785 9.74026 11.995 9.74026H12.005C12.6215 9.74026 13.1213 10.2386 13.1213 10.8534C13.1213 11.4682 12.6215 11.9666 12.005 11.9666H11.995C11.3785 11.9666 10.8787 11.4682 10.8787 10.8534ZM7.52875 9.74026C6.91225 9.74026 6.41247 10.2386 6.41247 10.8534C6.41247 11.4682 6.91225 11.9666 7.52875 11.9666H7.53878C8.15528 11.9666 8.65506 11.4682 8.65506 10.8534C8.65506 10.2386 8.15528 9.74026 7.53878 9.74026H7.52875Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Inbox</p>
      </div>
    </li>

    <li class="cursor-pointer" [routerLink]="['/finance']" [ngClass]="{ activelist: currentRoute === 'finance' }"  *ngIf="checkData('finances')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'finance' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M8.65116 24H15.3488C21.4102 24 24 21.4102 24 15.3488V8.65116C24 2.58977 21.4102 0 15.3488 0H8.65116C2.58977 0 0 2.58977 0 8.65116V15.3488C0 21.4102 2.58977 24 8.65116 24ZM1.67442 8.65116C1.67442 3.50512 3.50512 1.67442 8.65116 1.67442H15.3488C20.4949 1.67442 22.3256 3.50512 22.3256 8.65116V15.3488C22.3256 20.4949 20.4949 22.3256 15.3488 22.3256H8.65116C3.50512 22.3256 1.67442 20.4949 1.67442 15.3488V8.65116ZM9.90317 18.8651H14.1098L14.1234 18.865H18.3403C18.8091 18.865 19.1775 18.4854 19.1775 18.0277V14.2212C19.1775 13.0603 18.2287 12.1114 17.0677 12.1114H14.9581V7.24456C14.9581 6.08363 14.0093 5.13477 12.8484 5.13477H11.1516C9.99068 5.13477 9.04186 6.08363 9.04186 7.24456V10.2028H6.93155C5.77062 10.2028 4.8218 11.1517 4.8218 12.3126V18.028C4.8218 18.4856 5.20134 18.8652 5.65901 18.8652H9.88968L9.90317 18.8651ZM10.7274 17.1906H13.2724V12.9486C13.2724 12.9024 13.2763 12.8569 13.2837 12.8125V7.24456C13.2837 7.01014 13.094 6.80919 12.8484 6.80919H11.1516C10.9172 6.80919 10.7163 6.99898 10.7163 7.24456V10.9082C10.7233 10.9512 10.7269 10.9953 10.7269 11.04V17.1906H10.7274ZM17.5031 17.1905H14.9581V13.7858H17.0677C17.3133 13.7858 17.5031 13.9868 17.5031 14.2212V17.1905ZM9.04186 11.8884V17.1908H6.49622V12.3237C6.49622 12.0781 6.69713 11.8884 6.93155 11.8884H9.04186Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Finances</p>
      </div>
    </li>

    <li class="cursor-pointer" [routerLink]="['/staff']" [ngClass]="{ activelist: currentRoute === 'staff' }" *ngIf="currentUser.admin_role !== 'STAFF'">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'staff' }"
      >
        <svg
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M3.93104 6.4186C3.93104 9.95721 6.75634 12.8372 10.2277 12.8372C13.6991 12.8372 16.5244 9.95721 16.5244 6.4186C16.5244 2.88 13.6991 0 10.2277 0C6.75634 0 3.93104 2.88 3.93104 6.4186ZM5.57366 6.4186C5.57366 3.80651 7.66525 1.67442 10.2277 1.67442C12.7902 1.67442 14.8818 3.80651 14.8818 6.4186C14.8818 9.0307 12.7902 11.1628 10.2277 11.1628C7.66525 11.1628 5.57366 9.0307 5.57366 6.4186ZM0 23.1627C0 23.6204 0.372326 23.9999 0.821306 23.9999C1.27029 23.9999 1.64261 23.6204 1.64261 23.1627C1.64261 19.3115 5.49727 16.1859 10.228 16.1859C10.8737 16.1859 11.5097 16.2411 12.1291 16.3547C11.7819 17.0732 11.5968 17.8697 11.5968 18.6977C11.5968 19.6688 11.8596 20.6177 12.3414 21.4214C12.6042 21.8791 12.9437 22.2921 13.327 22.627C14.2797 23.5089 15.5062 24 16.7984 24C18.6162 24 20.3245 23.0177 21.2334 21.4326C21.5182 20.9749 21.7262 20.4502 21.8357 19.9479C21.9453 19.546 22 19.1219 22 18.6977C22 17.3805 21.5182 16.1303 20.664 15.1591C19.7003 14.0428 18.2877 13.3953 16.7984 13.3953C15.4318 13.3953 14.156 13.92 13.1842 14.8803C12.2224 14.6317 11.2343 14.5115 10.228 14.5115C4.58836 14.5115 0 18.3962 0 23.1627ZM16.7984 15.0698C15.8238 15.0698 14.9258 15.4604 14.2469 16.1637C13.6008 16.8446 13.2394 17.7377 13.2394 18.6977C13.2394 19.3563 13.4146 20.0037 13.7541 20.5618C13.9293 20.8744 14.1592 21.1535 14.4221 21.3879C15.0791 22.0018 15.9223 22.3368 16.7984 22.3368C18.0358 22.3368 19.2076 21.667 19.8427 20.5842C20.0289 20.2716 20.1712 19.9144 20.2479 19.5684C20.3245 19.2782 20.3574 18.9991 20.3574 18.7088C20.3574 17.8158 20.0289 16.9563 19.4375 16.2865C18.7805 15.5051 17.8168 15.0698 16.7984 15.0698ZM16.1626 16H15V21H16.1394V19.4473H16.5611L17.8262 21H19L17.5069 19.0872L19 17.5345H17.7581L16.5155 18.8653H16.1626V16Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Staff</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'category' }"
      [routerLink]="['/category']"
      *ngIf="checkData('categories')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'category' }"
      >
        <svg
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M0 2C0 0.893333 0.869189 0 1.94595 0C3.0227 0 3.89189 0.893333 3.89189 2C3.89189 3.10667 3.0227 4 1.94595 4C0.869189 4 0 3.10667 0 2ZM0 9.9999C0 8.89324 0.869189 7.99991 1.94595 7.99991C3.0227 7.99991 3.89189 8.89324 3.89189 9.9999C3.89189 11.1066 3.0227 11.9999 1.94595 11.9999C0.869189 11.9999 0 11.1066 0 9.9999ZM1.94595 15.9998C0.869189 15.9998 0 16.9065 0 17.9998C0 19.0931 0.882162 19.9998 1.94595 19.9998C3.00973 19.9998 3.89189 19.0931 3.89189 17.9998C3.89189 16.9065 3.0227 15.9998 1.94595 15.9998ZM24.0001 19.3334H5.83789V16.6668H24.0001V19.3334ZM5.83789 11.3335H24.0001V8.66686H5.83789V11.3335ZM5.83789 3.33312V0.66645H24.0001V3.33312H5.83789Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Categories</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'radio' }"
      [routerLink]="['/radio']"
      *ngIf="checkData('radio_stations')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'radio' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M6.46789 0.116412C5.97978 -0.141995 5.37462 0.0442094 5.11621 0.532312C4.85781 1.02042 5.04401 1.62558 5.53211 1.88399L21.4679 10.3206C21.7953 10.4939 22 10.834 22 11.2044V21.0002C22 21.5525 21.5523 22.0002 21 22.0002H3C2.44772 22.0002 2 21.5525 2 21.0002V11.0002C2 10.4479 2.44772 10.0002 3 10.0002H14C14.5523 10.0002 15 9.55249 15 9.0002C15 8.44792 14.5523 8.0002 14 8.0002H3C1.34315 8.0002 0 9.34335 0 11.0002V21.0002C0 22.6571 1.34315 24.0002 3 24.0002H21C22.6569 24.0002 24 22.6571 24 21.0002V11.2044C24 10.0931 23.3858 9.07293 22.4037 8.553L6.46789 0.116412ZM10 16.0002C10 17.1048 9.10457 18.0002 8 18.0002C6.89543 18.0002 6 17.1048 6 16.0002C6 14.8957 6.89543 14.0002 8 14.0002C9.10457 14.0002 10 14.8957 10 16.0002ZM12 16.0002C12 18.2094 10.2091 20.0002 8 20.0002C5.79086 20.0002 4 18.2094 4 16.0002C4 13.7911 5.79086 12.0002 8 12.0002C10.2091 12.0002 12 13.7911 12 16.0002ZM14 14.0002C14 13.448 14.4477 13.0002 15 13.0002H19C19.5523 13.0002 20 13.448 20 14.0002C20 14.5525 19.5523 15.0002 19 15.0002H15C14.4477 15.0002 14 14.5525 14 14.0002ZM15 17.0002C14.4477 17.0002 14 17.448 14 18.0002C14 18.5525 14.4477 19.0002 15 19.0002H19C19.5523 19.0002 20 18.5525 20 18.0002C20 17.448 19.5523 17.0002 19 17.0002H15Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Radio stations</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'fan-club-plans' }"
      [routerLink]="['/fan-club-plans']"
      *ngIf="checkData('fan_club_plans')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'fan-club-plans' }"
      >
        <!-- <img src="assets/images/fan-club.png" /> -->
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
          <g id="surface1">
          <path fill="#D1D6DC" d="M 7.125 0.375 C 10.34375 0.375 13.558594 0.375 16.875 0.375 C 16.875 2.230469 16.875 4.085938 16.875 6 C 19.101562 6 21.328125 6 23.625 6 C 23.625 8.226562 23.625 10.453125 23.625 12.75 C 22.324219 12.933594 22.324219 12.933594 21 13.125 C 20.355469 13.621094 20.355469 13.621094 19.96875 14.273438 C 19.550781 14.820312 19.550781 14.820312 19.125 15.375 C 18.753906 15.375 18.382812 15.375 18 15.375 C 18 14.507812 18 13.640625 18 12.75 C 17.132812 12.75 16.265625 12.75 15.375 12.75 C 15.375 11.390625 15.375 10.027344 15.375 8.625 C 14.757812 8.625 14.136719 8.625 13.5 8.625 C 13.429688 9.3125 13.429688 9.3125 13.359375 10.007812 C 13.203125 11.273438 12.917969 12.335938 12.375 13.5 C 11.820312 13.316406 11.820312 13.316406 11.25 13.125 C 10.746094 11.507812 10.5 10.320312 10.5 8.625 C 9.882812 8.625 9.261719 8.625 8.625 8.625 C 8.625 9.738281 8.625 10.851562 8.625 12 C 7.757812 12 6.890625 12 6 12 C 6 13.113281 6 14.226562 6 15.375 C 5.628906 15.375 5.257812 15.375 4.875 15.375 C 4.382812 14.636719 4.015625 13.867188 3.625 13.070312 C 2.859375 12.066406 2.859375 12.066406 0.375 12 C 0.375 9.773438 0.375 7.546875 0.375 5.25 C 2.601562 5.25 4.828125 5.25 7.125 5.25 C 7.125 3.640625 7.125 2.03125 7.125 0.375 Z M 7.875 1.125 C 7.875 3.351562 7.875 5.578125 7.875 7.875 C 8.988281 8 10.101562 8.121094 11.25 8.25 C 11.375 8.746094 11.496094 9.238281 11.625 9.75 C 11.871094 9.75 12.121094 9.75 12.375 9.75 C 12.5 9.253906 12.621094 8.761719 12.75 8.25 C 13.863281 8.125 14.976562 8.003906 16.125 7.875 C 16.125 5.648438 16.125 3.421875 16.125 1.125 C 13.402344 1.125 10.679688 1.125 7.875 1.125 Z M 1.125 6 C 1.125 7.734375 1.125 9.464844 1.125 11.25 C 2.113281 11.25 3.105469 11.25 4.125 11.25 C 4.25 11.621094 4.371094 11.992188 4.5 12.375 C 4.625 12.003906 4.746094 11.632812 4.875 11.25 C 5.863281 11.25 6.855469 11.25 7.875 11.25 C 7.875 10.382812 7.875 9.515625 7.875 8.625 C 7.628906 8.625 7.378906 8.625 7.125 8.625 C 7.125 7.757812 7.125 6.890625 7.125 6 C 5.144531 6 3.164062 6 1.125 6 Z M 16.875 6.75 C 16.875 7.367188 16.875 7.988281 16.875 8.625 C 16.628906 8.625 16.378906 8.625 16.125 8.625 C 16.125 9.738281 16.125 10.851562 16.125 12 C 17.113281 12 18.105469 12 19.125 12 C 19.25 12.371094 19.371094 12.742188 19.5 13.125 C 19.625 12.878906 19.746094 12.628906 19.875 12.375 C 20.867188 12.152344 21.859375 12.097656 22.875 12 C 22.875 10.265625 22.875 8.535156 22.875 6.75 C 20.894531 6.75 18.914062 6.75 16.875 6.75 Z M 16.875 6.75 "/>
          <path fill="#D1D6DC" d="M 17.976562 16.054688 C 19.125 16.125 19.125 16.125 19.875 16.875 C 20.742188 19.148438 20.683594 21.203125 20.625 23.625 C 18.890625 23.625 17.160156 23.625 15.375 23.625 C 15.273438 20.898438 15.351562 18.980469 16.5 16.5 C 16.875 16.125 16.875 16.125 17.976562 16.054688 Z M 17.25 17.25 C 17.25 17.621094 17.25 17.992188 17.25 18.375 C 17.742188 18.253906 18.238281 18.128906 18.75 18 C 18.625 17.753906 18.5 17.507812 18.375 17.25 C 18.003906 17.25 17.632812 17.25 17.25 17.25 Z M 16.59375 19.921875 C 15.933594 20.914062 16.050781 21.710938 16.125 22.875 C 17.363281 22.875 18.597656 22.875 19.875 22.875 C 20.007812 21.3125 20.007812 21.3125 19.40625 19.921875 C 18.410156 19.285156 17.585938 19.285156 16.59375 19.921875 Z M 16.59375 19.921875 "/>
          <path fill="#D1D6DC" d="M 11.976562 16.054688 C 13.125 16.125 13.125 16.125 13.875 16.875 C 14.742188 19.148438 14.683594 21.203125 14.625 23.625 C 12.890625 23.625 11.160156 23.625 9.375 23.625 C 9.273438 20.898438 9.351562 18.980469 10.5 16.5 C 10.875 16.125 10.875 16.125 11.976562 16.054688 Z M 11.25 17.25 C 11.25 17.621094 11.25 17.992188 11.25 18.375 C 11.742188 18.253906 12.238281 18.128906 12.75 18 C 12.625 17.753906 12.5 17.507812 12.375 17.25 C 12.003906 17.25 11.632812 17.25 11.25 17.25 Z M 10.59375 19.921875 C 9.933594 20.914062 10.050781 21.710938 10.125 22.875 C 11.363281 22.875 12.597656 22.875 13.875 22.875 C 14.007812 21.3125 14.007812 21.3125 13.40625 19.921875 C 12.410156 19.285156 11.585938 19.285156 10.59375 19.921875 Z M 10.59375 19.921875 "/>
          <path fill="#D1D6DC" d="M 5.976562 16.054688 C 7.125 16.125 7.125 16.125 7.875 16.875 C 8.742188 19.148438 8.683594 21.203125 8.625 23.625 C 6.890625 23.625 5.160156 23.625 3.375 23.625 C 3.273438 20.898438 3.351562 18.980469 4.5 16.5 C 4.875 16.125 4.875 16.125 5.976562 16.054688 Z M 5.25 17.25 C 5.25 17.621094 5.25 17.992188 5.25 18.375 C 5.742188 18.253906 6.238281 18.128906 6.75 18 C 6.625 17.753906 6.5 17.507812 6.375 17.25 C 6.003906 17.25 5.632812 17.25 5.25 17.25 Z M 4.59375 19.921875 C 3.933594 20.914062 4.050781 21.710938 4.125 22.875 C 5.363281 22.875 6.597656 22.875 7.875 22.875 C 8.007812 21.3125 8.007812 21.3125 7.40625 19.921875 C 6.410156 19.285156 5.585938 19.285156 4.59375 19.921875 Z M 4.59375 19.921875 "/>
          <path fill="#D1D6DC" d="M 10.757812 2.199219 C 11.167969 2.199219 11.578125 2.203125 12 2.203125 C 12.410156 2.203125 12.820312 2.199219 13.242188 2.199219 C 14.25 2.25 14.25 2.25 14.625 2.625 C 14.835938 4.15625 14.742188 4.714844 13.804688 5.976562 C 12.75 6.75 12.75 6.75 11.789062 6.773438 C 10.671875 6.285156 10.097656 5.863281 9.375 4.875 C 9.257812 3.679688 9.257812 3.679688 9.375 2.625 C 9.75 2.25 9.75 2.25 10.757812 2.199219 Z M 10.5 3.375 C 10.574219 4.105469 10.574219 4.105469 10.875 4.875 C 11.621094 5.359375 11.621094 5.359375 12.375 5.625 C 12.960938 5.132812 12.960938 5.132812 13.5 4.5 C 13.5 4.128906 13.5 3.757812 13.5 3.375 C 12.507812 3.375 11.519531 3.375 10.5 3.375 Z M 10.5 3.375 "/>
          <path fill="#D1D6DC" d="M 17.625 7.875 C 18.863281 7.875 20.101562 7.875 21.375 7.875 C 21.511719 9.902344 21.511719 9.902344 20.929688 10.851562 C 20.25 11.25 20.25 11.25 19.289062 11.179688 C 18.375 10.875 18.375 10.875 17.625 10.125 C 17.578125 8.953125 17.578125 8.953125 17.625 7.875 Z M 18.75 9 C 18.875 9.371094 18.996094 9.742188 19.125 10.125 C 19.496094 10 19.867188 9.878906 20.25 9.75 C 20.125 9.503906 20.003906 9.253906 19.875 9 C 19.503906 9 19.132812 9 18.75 9 Z M 18.75 9 "/>
          <path fill="#D1D6DC" d="M 2.625 7.125 C 3.863281 7.125 5.101562 7.125 6.375 7.125 C 6.511719 9.152344 6.511719 9.152344 5.929688 10.101562 C 5.25 10.5 5.25 10.5 4.289062 10.429688 C 3.375 10.125 3.375 10.125 2.625 9.375 C 2.578125 8.203125 2.578125 8.203125 2.625 7.125 Z M 3.75 8.25 C 3.875 8.621094 3.996094 8.992188 4.125 9.375 C 4.496094 9.25 4.867188 9.128906 5.25 9 C 5.125 8.753906 5.003906 8.503906 4.875 8.25 C 4.503906 8.25 4.132812 8.25 3.75 8.25 Z M 3.75 8.25 "/>
          </g>
          </svg>

        <p class="item_text">Fan Club Plans</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'token' }"
      [routerLink]="['/token']"
      *ngIf="checkData('tokens')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'token' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Tokens</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'Subscription' }"
      [routerLink]="['/Subscription']"
      *ngIf="checkData('subscription_plans')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'Subscription' }"
      >
        <!-- <img src="assets/images/subscription.png" class="Subscription-img" /> -->
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
          <g id="surface1">
          <path fill="#D1D6DC" d="M 1.921875 3.359375 C 8.890625 3.359375 15.859375 3.359375 23.039062 3.359375 C 23.25 9.332031 23.25 9.332031 23.3125 11.210938 C 23.34375 11.941406 23.34375 11.941406 23.367188 12.6875 C 23.394531 13.441406 23.394531 13.441406 23.417969 14.203125 C 23.394531 15.335938 23.394531 15.335938 24 15.839844 C 24.308594 18.214844 24.34375 20.058594 23.097656 22.136719 C 20.992188 23.40625 19.199219 23.535156 16.800781 23.039062 C 15.300781 21.960938 15.300781 21.960938 14.398438 20.640625 C 14.398438 20.007812 14.398438 19.371094 14.398438 18.71875 C 10.28125 18.71875 6.164062 18.71875 1.921875 18.71875 C 1.921875 13.652344 1.921875 8.582031 1.921875 3.359375 Z M 2.878906 4.320312 C 2.878906 4.636719 2.878906 4.953125 2.878906 5.28125 C 3.652344 5.980469 4.460938 6.644531 5.28125 7.292969 C 7.574219 9.125 9.804688 11.007812 12 12.960938 C 14.136719 12.273438 15.421875 11.195312 17.039062 9.65625 C 18.34375 8.429688 19.621094 7.242188 21.042969 6.144531 C 21.390625 5.859375 21.730469 5.574219 22.078125 5.28125 C 22.078125 4.964844 22.078125 4.644531 22.078125 4.320312 C 15.742188 4.320312 9.40625 4.320312 2.878906 4.320312 Z M 17.722656 10.828125 C 17.449219 11.082031 17.179688 11.34375 16.894531 11.605469 C 16.644531 11.839844 16.398438 12.078125 16.140625 12.320312 C 14.730469 13.472656 13.839844 13.953125 12 13.800781 C 10.734375 13.484375 9.78125 13.078125 8.640625 12.480469 C 7.847656 13.097656 7.0625 13.71875 6.269531 14.34375 C 5.832031 14.683594 5.390625 15.027344 4.9375 15.382812 C 3.8125 16.21875 3.8125 16.21875 3.359375 17.28125 C 4.742188 17.742188 5.605469 17.816406 7.042969 17.808594 C 7.46875 17.804688 7.894531 17.804688 8.335938 17.804688 C 8.785156 17.796875 9.230469 17.792969 9.691406 17.789062 C 10.140625 17.789062 10.59375 17.785156 11.058594 17.785156 C 12.171875 17.777344 13.285156 17.769531 14.398438 17.761719 C 14.53125 17.21875 14.660156 16.671875 14.789062 16.109375 C 14.976562 15.546875 15.167969 14.980469 15.359375 14.398438 C 17.585938 13.65625 19.738281 13.890625 22.078125 13.921875 C 22.078125 11.703125 22.078125 9.484375 22.078125 7.199219 C 20.769531 7.199219 18.710938 9.882812 17.722656 10.828125 Z M 3.359375 7.679688 C 3.359375 9.898438 3.359375 12.113281 3.359375 14.398438 C 5.230469 13.464844 6.257812 12.542969 7.679688 11.039062 C 7.050781 10.476562 6.421875 9.917969 5.789062 9.359375 C 5.4375 9.046875 5.089844 8.734375 4.726562 8.414062 C 3.96875 7.628906 3.96875 7.628906 3.359375 7.679688 Z M 16.617188 15.65625 C 15.605469 17.140625 15.546875 17.917969 15.839844 19.679688 C 16.558594 20.878906 16.558594 20.878906 17.761719 21.601562 C 19.523438 21.894531 20.300781 21.835938 21.78125 20.824219 C 22.796875 19.339844 22.851562 18.5625 22.558594 16.800781 C 21.839844 15.601562 21.839844 15.601562 20.640625 14.878906 C 18.878906 14.585938 18.101562 14.644531 16.617188 15.65625 Z M 16.617188 15.65625 "/>
          <path fill="#D1D6DC" d="M 0 1.441406 C 7.128906 1.441406 14.257812 1.441406 21.601562 1.441406 C 21.601562 1.757812 21.601562 2.074219 21.601562 2.398438 C 14.789062 2.398438 7.976562 2.398438 0.960938 2.398438 C 0.960938 7.152344 0.960938 11.902344 0.960938 16.800781 C 0.644531 16.800781 0.328125 16.800781 0 16.800781 C 0 11.730469 0 6.664062 0 1.441406 Z M 0 1.441406 "/>
          <path fill="#D1D6DC" d="M 18.71875 15.359375 C 19.035156 15.359375 19.355469 15.359375 19.679688 15.359375 C 19.679688 16.152344 19.679688 16.945312 19.679688 17.761719 C 20.472656 17.761719 21.265625 17.761719 22.078125 17.761719 C 22.078125 18.234375 22.078125 18.710938 22.078125 19.199219 C 21.445312 19.199219 20.8125 19.199219 20.160156 19.199219 C 20.160156 19.832031 20.160156 20.46875 20.160156 21.121094 C 19.683594 21.121094 19.210938 21.121094 18.71875 21.121094 C 18.71875 20.488281 18.71875 19.851562 18.71875 19.199219 C 17.929688 19.042969 17.136719 18.882812 16.320312 18.71875 C 16.320312 18.402344 16.320312 18.085938 16.320312 17.761719 C 16.953125 17.761719 17.585938 17.761719 18.238281 17.761719 C 18.398438 16.96875 18.558594 16.175781 18.71875 15.359375 Z M 18.71875 15.359375 "/>
          </g>
          </svg>

        <p class="item_text">Subscription Plan</p>
      </div>
    </li>
    <li class="cursor-pointer" [routerLink]="['/promo-code']" [ngClass]="{ activelist: currentRoute === 'promo-code' }" *ngIf="checkData('promo_codes')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'promo-code' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M9.76657 24H17.5814C22.5042 24 24 22.1623 24 16.1143C24 15.552 23.6205 15.0857 23.1628 15.0857C22.0912 15.0857 21.2093 14.0023 21.2093 12.6857C21.2093 11.3691 22.0912 10.2857 23.1628 10.2857C23.6205 10.2857 24 9.81943 24 9.25714V7.88571C24 1.83771 22.5042 0 17.5814 0H9.76657H6.4186C1.49581 0 0 1.83771 0 7.88571V8.57143C0 9.13371 0.379535 9.6 0.837209 9.6C1.90884 9.6 2.7907 10.6834 2.7907 12C2.7907 13.3166 1.90884 14.4 0.837209 14.4C0.379535 14.4 0 14.8663 0 15.4286V16.1143C0 22.1623 1.49581 24 6.4186 24H9.76657ZM8.92936 21.9429H6.4186C2.4893 21.9429 1.69674 21.0514 1.67442 16.3337C3.2707 15.8674 4.46512 14.0983 4.46512 12C4.46512 9.90171 3.2707 8.13257 1.67442 7.66629C1.69674 2.94857 2.4893 2.05714 6.4186 2.05714H8.92936V4.45714C8.92936 5.01943 9.30889 5.48571 9.76657 5.48571C10.2242 5.48571 10.6038 5.01943 10.6038 4.45714V2.05714H17.5814C21.5777 2.05714 22.3256 2.98971 22.3256 7.88571V8.352C20.7293 8.81829 19.5349 10.5874 19.5349 12.6857C19.5349 14.784 20.7181 16.5531 22.3144 17.0194C22.214 21.1337 21.3098 21.9429 17.5814 21.9429H10.6038V19.5429C10.6038 18.9806 10.2242 18.5143 9.76657 18.5143C9.30889 18.5143 8.92936 18.9806 8.92936 19.5429V21.9429ZM9.76657 15.5386C9.30889 15.5386 8.92936 15.0723 8.92936 14.5101V9.47692C8.92936 8.91464 9.30889 8.44835 9.76657 8.44835C10.2242 8.44835 10.6038 8.91464 10.6038 9.47692V14.5101C10.6038 15.0861 10.2242 15.5386 9.76657 15.5386Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Promo codes</p>
      </div>
    </li>
    <li class="cursor-pointer" [routerLink]="['/policy']" [ngClass]="{'active': currentRoute === 'policy'}" *ngIf="checkData('policy')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'policy' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M9.76657 24H17.5814C22.5042 24 24 22.1623 24 16.1143C24 15.552 23.6205 15.0857 23.1628 15.0857C22.0912 15.0857 21.2093 14.0023 21.2093 12.6857C21.2093 11.3691 22.0912 10.2857 23.1628 10.2857C23.6205 10.2857 24 9.81943 24 9.25714V7.88571C24 1.83771 22.5042 0 17.5814 0H9.76657H6.4186C1.49581 0 0 1.83771 0 7.88571V8.57143C0 9.13371 0.379535 9.6 0.837209 9.6C1.90884 9.6 2.7907 10.6834 2.7907 12C2.7907 13.3166 1.90884 14.4 0.837209 14.4C0.379535 14.4 0 14.8663 0 15.4286V16.1143C0 22.1623 1.49581 24 6.4186 24H9.76657ZM8.92936 21.9429H6.4186C2.4893 21.9429 1.69674 21.0514 1.67442 16.3337C3.2707 15.8674 4.46512 14.0983 4.46512 12C4.46512 9.90171 3.2707 8.13257 1.67442 7.66629C1.69674 2.94857 2.4893 2.05714 6.4186 2.05714H8.92936V4.45714C8.92936 5.01943 9.30889 5.48571 9.76657 5.48571C10.2242 5.48571 10.6038 5.01943 10.6038 4.45714V2.05714H17.5814C21.5777 2.05714 22.3256 2.98971 22.3256 7.88571V8.352C20.7293 8.81829 19.5349 10.5874 19.5349 12.6857C19.5349 14.784 20.7181 16.5531 22.3144 17.0194C22.214 21.1337 21.3098 21.9429 17.5814 21.9429H10.6038V19.5429C10.6038 18.9806 10.2242 18.5143 9.76657 18.5143C9.30889 18.5143 8.92936 18.9806 8.92936 19.5429V21.9429ZM9.76657 15.5386C9.30889 15.5386 8.92936 15.0723 8.92936 14.5101V9.47692C8.92936 8.91464 9.30889 8.44835 9.76657 8.44835C10.2242 8.44835 10.6038 8.91464 10.6038 9.47692V14.5101C10.6038 15.0861 10.2242 15.5386 9.76657 15.5386Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Policy</p>
      </div>
    </li>

    <li class="cursor-pointer" [routerLink]="['/ads']" [ngClass]="{ activelist: currentRoute === 'ads' }"  *ngIf="checkData('kwot_ads')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'ads' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Kwot ads</p>
      </div>
    </li>
    <li class="cursor-pointer" [routerLink]="['/campaigns']" [ngClass]="{ activelist: currentRoute === 'campaigns' }"  *ngIf="checkData('kwot_ads')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'campaigns' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Campaigns</p>
      </div>
    </li>
    <li class="cursor-pointer" [routerLink]="['/token-cost']" [ngClass]="{ activelist: currentRoute === 'token-cost' }"  *ngIf="checkData('token_cost')">
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'token-cost' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>

        <p class="item_text">Token Cost</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'commission' }"
      [routerLink]="['/commission']"
      *ngIf="checkData('commission')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'commission' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Platform Commission</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'referral-reward' }"
      [routerLink]="['/referral-reward']"
      *ngIf="checkData('referral-reward')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'referral-reward' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Referral Reward</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'referral-level' }"
      [routerLink]="['/referral-level']"
      *ngIf="checkData('referral-level')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'referral-level' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Referral Level</p>
      </div>
    </li>

    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'referral-milestone' }"
      [routerLink]="['/referral-milestone']"
      *ngIf="checkData('referral-milestone')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'referral-milestone' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Referral Milestone</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'user-tokens' }"
      [routerLink]="['/user-tokens']"
      *ngIf="checkData('user-tokens')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'user-tokens' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            class="active_icon"
            d="M16.4651 24H1.95349C0.88186 24 0 23.1181 0 22.0465V7.53488C0 2.60093 2.60093 0 7.53488 0H16.4651C21.3991 0 24 2.60093 24 7.53488V16.4651C24 21.3991 21.3991 24 16.4651 24ZM7.53488 1.67442C3.5386 1.67442 1.67442 3.5386 1.67442 7.53488V22.0465C1.67442 22.2028 1.79721 22.3256 1.95349 22.3256H16.4651C20.4614 22.3256 22.3256 20.4614 22.3256 16.4651V7.53488C22.3256 3.5386 20.4614 1.67442 16.4651 1.67442H7.53488ZM17.5812 10.0465H6.41839C5.96071 10.0465 5.58118 9.66698 5.58118 9.2093C5.58118 8.75163 5.96071 8.37209 6.41839 8.37209H17.5812C18.0389 8.37209 18.4184 8.75163 18.4184 9.2093C18.4184 9.66698 18.0389 10.0465 17.5812 10.0465ZM6.41839 15.6277H14.2323C14.69 15.6277 15.0695 15.2482 15.0695 14.7905C15.0695 14.3328 14.69 13.9533 14.2323 13.9533H6.41839C5.96071 13.9533 5.58118 14.3328 5.58118 14.7905C5.58118 15.2482 5.96071 15.6277 6.41839 15.6277Z"
            fill="#D1D6DC"
          />
        </svg>
        <p class="item_text">Users Tokens</p>
      </div>
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'distribute-tokens' }"
      [routerLink]="['/distribute-tokens']"
      *ngIf="checkData('distribute-tokens')"
    >
<!--      <div-->
<!--        class="lsit_item"-->
<!--        [ngClass]="{ list_active: currentRoute === 'distribute-tokens' }"-->
<!--      >-->
<!--        <img class="img-wrapper w-auto coin-icon" src="assets/images/token-coin.png" />-->
<!--        <p class="item_text">Distribute Tokens</p>-->
<!--      </div>-->
    </li>
    <li
      class="cursor-pointer"
      [ngClass]="{ activelist: currentRoute === 'users-streams' }"
      [routerLink]="['/users-streams']"
      *ngIf="checkData('users-streams')"
    >
      <div
        class="lsit_item"
        [ngClass]="{ list_active: currentRoute === 'users-streams' }"
      >
        <img class="img-wrapper w-auto coin-icon" src="assets/images/Streams.svg" />
        <p class="item_text">Users Streams</p>
      </div>
    </li>
  </ul>
</aside>
